<template>
        <div id="container">
                <GChart id="graph"
                        type="LineChart"
                        :data="chartData"
                        :options="chartOptions"
                />
        </div>
</template>

<script>
    import {GChart} from 'vue-google-charts'
    import {getComponents} from "../model/model";

    export default {
        name: "IndividualForcings",

        props: ['amplitudes', 'start', 'end'],

        components: {
            GChart
        },

        computed: {

            chartData: function () {
                let f1 = this.$props.amplitudes.enso;
                let f2 = this.$props.amplitudes.volc;
                let f3 = this.$props.amplitudes.sol;
                let f4 = this.$props.amplitudes.anth;
                return getComponents(f1, f2, f3, f4);
            },

            chartOptions: function () {
                return {
                    legend: {position: 'in', alignment: 'start'},
                    title: 'Forcing Components',
                    colors: ['#009E73', '#E73B00', '#E69F00', '#0072B2'],
                    chartArea: {
                        width: '85%'
                    },
                    hAxis: {
                        format: "0000",
                        titleTextStyle: {fontSize: 16},
                        viewWindow: {min: this.$props.start, max: this.$props.end}
                    },
                    vAxis: {
                        viewWindow: {
                            min: -0.5,
                            max: 0.5
                        },
                        title: 'Ta (ºC)',
                        titleTextStyle: {fontSize: 16}
                    },
                    chart: {
                        curveType: 'function'
                    }
                }
            }
        }
    }
</script>

<style scoped>

        #container {
                height: 30vw;
                min-height: 200px;
        }

        #graph {
                height: 100%;

        }

</style>
